import * as React from 'react';
import { Row, Button, Divider, notification } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import ProductVideo from './ProductVideo';
import ProductVideoDetail from './ProductVideoDetail';

interface IProductVideosProps {
  productVideos: Array<GQL.IProductVideo>;
  productId: string;
  onChange: (videos: Array<GQL.IProductVideo>) => void;
  language: string;
}

interface IProductVideosState {
  videos: Array<GQL.IProductVideo>;
  currentVideo: GQL.IProductVideo | undefined | null;
}

export default class ProductVideos extends React.Component<IProductVideosProps, IProductVideosState> {

  constructor(props: IProductVideosProps) {
    super(props);

    this.state = {
      videos: props && props.productVideos ? [...props.productVideos] : [],
      currentVideo: null,
    };

    this.setCurrentProductVideo = this.setCurrentProductVideo.bind(this);
  }

  public render() {
    const { language } = this.props;

    return (
      <Row>
        <div style={{ width: '100%', maxWidth: 500 }}>
          <Button onClick={(e: any) => this.setCurrentProductVideo(undefined)}>
            <PlusOutlined /> Add video
          </Button>
        </div>
        <Divider />
        <div>
          {this.state.videos && 
            this.state.videos.map((video: GQL.IProductVideo, index: number) => {
              return (
                <div style={{ float: 'left', margin: '0 16px 16px 0' }} key={index}>
                  <ProductVideo 
                    video={video}
                    language={language}
                    onEdit={(video: GQL.IProductVideo) => this.setCurrentProductVideo(video)}
                    onDelete={(video: GQL.IProductVideo) => this.onDelete(video)}
                  />
                </div>);
            })}
        </div>

        {this.state.currentVideo !== null &&
          <ProductVideoDetail 
            productId={this.props.productId}
            video={this.state.currentVideo}
            onClose={(e: any) => this.setCurrentProductVideo(null)}
            onSave={(video: any) => this.upsert(video)}
          />}
      </Row>
    );
  }

  private setCurrentProductVideo(video: GQL.IProductVideo | undefined | null) {
    this.setState({
      currentVideo: video,
    });
  }

  private onDelete(productVideo: GQL.IProductVideo) {
    const videos = [...this.state.videos].filter((video: GQL.IProductVideo) => video.id !== productVideo.id);

    this.setState({ 
      videos
    }, () => {
      this.props.onChange(videos);
      this.setCurrentProductVideo(null);
    });
  }

  private getNextPriority() {
    return this.state.videos.reduce((acc: number, current: GQL.IProductVideo) => {
      if (current && current.priority && current.priority >= acc) {
        acc = current.priority+1;
      }
      return acc;
    }, 1);
  }
  
  private upsert(
    productVideo: GQL.IProductVideo,
  ) {
    if (productVideo !== undefined) {
      const videos = [...this.state.videos];

      // nahrazeni share linku za emdeb
      productVideo.url = productVideo.url.replace('https://youtu.be/', 'https://www.youtube.com/embed/');

      if (productVideo.id) {
        // aktualizace
        videos.map((video: GQL.IProductVideo) => {
          if (video.id === productVideo.id) {
            video.url = productVideo.url;
            video.title = productVideo.title;
          }
          return video;
        });
      } else {

        // nové video
        const video = {...productVideo};
        video.productId = this.props.productId;
        video.title = productVideo.title || {};
        video.visible = true;
        video.priority = this.getNextPriority();
        videos.push(video);
      }

      this.setState({ 
        videos: videos 
      }, () => {
        this.props.onChange(videos);
        this.setCurrentProductVideo(null);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/ProductVideos/ProductVideos.tsx